import _ from 'lodash'
import type {CssValue} from '../../constants'

interface Unit<T extends string> {
    value: number
    type: T
}

export const serializeUnit = <T extends string>({value, type}: Unit<T>, validTypes: Set<T>): CssValue | undefined => {
    if (!_.isNumber(value) || !_.isString(type) || !validTypes.has(type)) {
        return undefined
    }

    return `${value}${type}`
}

export const deserializeUnit = <T extends string>(rule: CssValue, validTypes: Set<T>): Unit<T> | undefined => {
    const [match, value, unit] = rule.match(/^([+-]?[0-9]+(?:\.[0-9]+)?(?:[Ee][+-]?[0-9]+)?)([a-zA-Z%]+)$/) ?? []

    if (!match || !validTypes.has(unit as T)) {
        return undefined
    }

    return {
        value: +value,
        type: unit as T
    }
}
